import { render, staticRenderFns } from "./LabelsOption.vue?vue&type=template&id=4ab52df4&"
import script from "./LabelsOption.vue?vue&type=script&lang=js&"
export * from "./LabelsOption.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports